export default __webpack_public_path__ + "static/media/1-icon-list-view-focused.4d0eb813.svg";